import { render } from "./displayTimeAndBusstop.vue?vue&type=template&id=7cd3da38&scoped=true"
import script from "./displayTimeAndBusstop.vue?vue&type=script&lang=js"
export * from "./displayTimeAndBusstop.vue?vue&type=script&lang=js"

import "./displayTimeAndBusstop.vue?vue&type=style&index=0&id=7cd3da38&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7cd3da38"

export default script